[
  {
    "id": "m-starboard",
    "rule": 34,
    "cite": [
      "a",
      "32:b"
    ],
    "scope": "international",
    "name": {
      "en": "One short blast",
      "de": "Ein kurzer Ton"
    },
    "pattern": [
      {
        "kind": "short",
        "count": 1
      }
    ],
    "repeatS": 0,
    "meaning": {
      "en": "I am altering my course to starboard.",
      "de": "Ich ändere meinen Kurs nach Steuerbord."
    },
    "explanation": {
      "de": "Ein kurzer Ton dauert etwa eine Sekunde. Das Signal meldet, was das Fahrzeug gerade tut, nämlich seinen Kurs nach Steuerbord ändern.",
      "en": "A short blast is of about one second duration. The signal reports what the vessel is doing, namely altering her course to starboard."
    },
    "context": "manoeuvre"
  },
  {
    "id": "m-port",
    "rule": 34,
    "cite": [
      "a",
      "32:b"
    ],
    "scope": "international",
    "name": {
      "en": "Two short blasts",
      "de": "Zwei kurze Töne"
    },
    "pattern": [
      {
        "kind": "short",
        "count": 2
      }
    ],
    "repeatS": 0,
    "meaning": {
      "en": "I am altering my course to port.",
      "de": "Ich ändere meinen Kurs nach Backbord."
    },
    "explanation": {
      "de": "Zwei kurze Töne, jeder etwa eine Sekunde. Wer sie hört, weiß, dass der andere nach Backbord dreht.",
      "en": "Two short blasts, each of about one second. Whoever hears them knows the other vessel is altering course to port."
    },
    "context": "manoeuvre"
  },
  {
    "id": "m-astern",
    "rule": 34,
    "cite": [
      "a"
    ],
    "scope": "international",
    "name": {
      "en": "Three short blasts",
      "de": "Drei kurze Töne"
    },
    "pattern": [
      {
        "kind": "short",
        "count": 3
      }
    ],
    "repeatS": 0,
    "meaning": {
      "en": "I am operating astern propulsion.",
      "de": "Meine Maschine geht rückwärts."
    },
    "explanation": {
      "de": "Drei kurze Töne melden, dass die Maschine rückwärts arbeitet.",
      "en": "Three short blasts report that the vessel is operating astern propulsion."
    },
    "context": "manoeuvre"
  },
  {
    "id": "w-doubt",
    "rule": 34,
    "cite": [
      "d"
    ],
    "scope": "both",
    "name": {
      "en": "Five short blasts",
      "de": "Fünf kurze Töne"
    },
    "pattern": [
      {
        "kind": "short",
        "count": 5
      }
    ],
    "repeatS": 0,
    "meaning": {
      "en": "I do not understand your intentions or doubt whether you are taking sufficient action.",
      "de": "Ich verstehe deine Absicht nicht oder zweifle, ob du genug tust."
    },
    "explanation": {
      "de": "Mindestens fünf kurze, schnelle Töne, wenn du die Absicht des anderen nicht verstehst oder daran zweifelst, dass er genug tut, um einen Zusammenstoß zu vermeiden. Ergänzen darfst du sie durch ebenso schnelle Lichtsignale.",
      "en": "At least five short and rapid blasts when you fail to understand the intentions of the other vessel or doubt whether she is taking sufficient action to avoid collision. You may supplement them with at least five short and rapid flashes."
    },
    "context": "warning"
  },
  {
    "id": "nc-overtake-stbd",
    "rule": 34,
    "cite": [
      "c",
      "c(i)",
      "9:e(i)"
    ],
    "scope": "international",
    "name": {
      "en": "Two prolonged, one short blast",
      "de": "Zwei lange, ein kurzer Ton"
    },
    "pattern": [
      {
        "kind": "prolonged",
        "count": 2
      },
      {
        "kind": "short",
        "count": 1
      }
    ],
    "repeatS": 0,
    "meaning": {
      "en": "I intend to overtake you on your starboard side.",
      "de": "Ich will dich an deiner Steuerbordseite überholen."
    },
    "explanation": {
      "de": "Nur im engen Fahrwasser, und nur nach Regel 9, wenn der Überholte für die sichere Vorbeifahrt etwas tun muss. Erst die beiden langen Töne, dann der kurze.",
      "en": "Only in a narrow channel, and only under Rule 9, where the vessel to be overtaken has to take action to permit safe passing. The two prolonged blasts come first, then the short one."
    },
    "context": "narrow-channel"
  },
  {
    "id": "nc-overtake-port",
    "rule": 34,
    "cite": [
      "c",
      "c(i)",
      "9:e(i)"
    ],
    "scope": "international",
    "name": {
      "en": "Two prolonged, two short blasts",
      "de": "Zwei lange, zwei kurze Töne"
    },
    "pattern": [
      {
        "kind": "prolonged",
        "count": 2
      },
      {
        "kind": "short",
        "count": 2
      }
    ],
    "repeatS": 0,
    "meaning": {
      "en": "I intend to overtake you on your port side.",
      "de": "Ich will dich an deiner Backbordseite überholen."
    },
    "explanation": {
      "de": "Zwei lange Töne, dann zwei kurze: \"Ich will dich an deiner Backbordseite überholen.\" Ein kurzer Ton mehr als beim Überholen an Steuerbord.",
      "en": "Two prolonged blasts, then two short ones: \"I intend to overtake you on your port side.\" One short blast more than for overtaking to starboard."
    },
    "context": "narrow-channel"
  },
  {
    "id": "nc-agreement",
    "rule": 34,
    "cite": [
      "c(ii)",
      "9:e(i)"
    ],
    "scope": "international",
    "name": {
      "en": "Prolonged, short, prolonged, short",
      "de": "Lang, kurz, lang, kurz"
    },
    "pattern": [
      {
        "kind": "prolonged",
        "count": 1
      },
      {
        "kind": "short",
        "count": 1
      },
      {
        "kind": "prolonged",
        "count": 1
      },
      {
        "kind": "short",
        "count": 1
      }
    ],
    "repeatS": 0,
    "meaning": {
      "en": "I agree, you may overtake.",
      "de": "Einverstanden, überhole."
    },
    "explanation": {
      "de": "Die Antwort des Überholten, der nach Regel 9 handelt: lang, kurz, lang, kurz, in dieser Reihenfolge.",
      "en": "The answer of the vessel about to be overtaken when acting under Rule 9: one prolonged, one short, one prolonged and one short blast, in that order."
    },
    "context": "narrow-channel"
  },
  {
    "id": "nc-bend",
    "rule": 34,
    "cite": [
      "e"
    ],
    "scope": "both",
    "name": {
      "en": "One prolonged blast",
      "de": "Ein langer Ton"
    },
    "pattern": [
      {
        "kind": "prolonged",
        "count": 1
      }
    ],
    "repeatS": 0,
    "meaning": {
      "en": "I am approaching a bend where other vessels may be obscured.",
      "de": "Ich komme an eine Biegung, in der du mich nicht sehen kannst."
    },
    "explanation": {
      "en": "One prolonged blast before the bend, and whoever hears it behind the bend answers the same way. The signal warns someone you cannot see.",
      "de": "Ein langer Ton vor der Biegung, und wer ihn hinter der Biegung hört, antwortet genauso. Das Signal warnt einen, den du nicht sehen kannst."
    },
    "context": "narrow-channel"
  },
  {
    "id": "rv-making-way",
    "rule": 35,
    "cite": [
      "a"
    ],
    "scope": "both",
    "name": {
      "en": "One prolonged blast every two minutes",
      "de": "Ein langer Ton, alle zwei Minuten"
    },
    "pattern": [
      {
        "kind": "prolonged",
        "count": 1
      }
    ],
    "repeatS": 120,
    "meaning": {
      "en": "Power-driven vessel making way through the water.",
      "de": "Maschinenfahrzeug mit Fahrt durchs Wasser."
    },
    "explanation": {
      "de": "Ein langer Ton, höchstens zwei Minuten Abstand, solange das Fahrzeug Fahrt durchs Wasser macht.",
      "en": "One prolonged blast at intervals of not more than two minutes, as long as the vessel is making way through the water."
    },
    "context": "restricted-visibility"
  },
  {
    "id": "rv-stopped",
    "rule": 35,
    "cite": [
      "b"
    ],
    "scope": "both",
    "name": {
      "en": "Two prolonged blasts every two minutes",
      "de": "Zwei lange Töne, alle zwei Minuten"
    },
    "pattern": [
      {
        "kind": "prolonged",
        "count": 2
      }
    ],
    "repeatS": 120,
    "meaning": {
      "en": "Power-driven vessel underway but stopped and making no way.",
      "de": "Maschinenfahrzeug in Fahrt, aber ohne Fahrt durchs Wasser."
    },
    "explanation": {
      "de": "Zwei lange Töne mit etwa zwei Sekunden dazwischen: das Fahrzeug ist in Fahrt, macht aber keine Fahrt durchs Wasser.",
      "en": "Two prolonged blasts with an interval of about two seconds between them: the vessel is underway but stopped and making no way through the water."
    },
    "context": "restricted-visibility"
  },
  {
    "id": "rv-restricted",
    "rule": 35,
    "cite": [
      "c"
    ],
    "scope": "both",
    "name": {
      "en": "One prolonged, two short blasts",
      "de": "Ein langer, zwei kurze Töne"
    },
    "pattern": [
      {
        "kind": "prolonged",
        "count": 1
      },
      {
        "kind": "short",
        "count": 2
      }
    ],
    "repeatS": 120,
    "meaning": {
      "en": "Not under command, restricted in ability to manoeuvre, constrained by draught, sailing, fishing or towing.",
      "de": "Manövrierunfähig, manövrierbehindert, tiefgangbehindert, Segelfahrzeug, Fischerei oder Schleppen."
    },
    "explanation": {
      "de": "Ein Signal für sechs Fälle: manövrierunfähig, manövrierbehindert, tiefgangbehindert, Segelfahrzeug, Fischerei, Schleppen oder Schieben. Es sagt nicht, welcher davon zutrifft.",
      "en": "One signal for six cases: not under command, restricted in her ability to maneuver, constrained by her draft, sailing, engaged in fishing, towing or pushing. It does not say which one applies."
    },
    "context": "restricted-visibility"
  },
  {
    "id": "rv-towed",
    "rule": 35,
    "cite": [
      "e"
    ],
    "scope": "both",
    "name": {
      "en": "One prolonged, three short blasts",
      "de": "Ein langer, drei kurze Töne"
    },
    "pattern": [
      {
        "kind": "prolonged",
        "count": 1
      },
      {
        "kind": "short",
        "count": 3
      }
    ],
    "repeatS": 120,
    "meaning": {
      "en": "A vessel towed, if manned.",
      "de": "Geschlepptes Fahrzeug, wenn es besetzt ist."
    },
    "explanation": {
      "de": "Vier Töne, ein langer und drei kurze, vom geschleppten Fahrzeug, wenn es besetzt ist, und zwar unmittelbar nach dem Signal des Schleppers.",
      "en": "Four blasts, one prolonged and three short, from the vessel towed if she is manned, made immediately after the signal of the towing vessel."
    },
    "context": "restricted-visibility"
  },
  {
    "id": "rv-anchored",
    "rule": 35,
    "cite": [
      "g"
    ],
    "scope": "both",
    "name": {
      "en": "Bell rung rapidly for five seconds every minute",
      "de": "Glocke, fünf Sekunden, jede Minute"
    },
    "pattern": [
      {
        "kind": "bell-rapid",
        "count": 1
      }
    ],
    "repeatS": 60,
    "meaning": {
      "en": "Vessel at anchor.",
      "de": "Ankerlieger."
    },
    "explanation": {
      "de": "Schnelles Läuten der Glocke, etwa fünf Sekunden lang, höchstens eine Minute Abstand. Ab 100 Metern Länge läutet die Glocke vorn und danach der Gong achtern.",
      "en": "Rapid ringing of the bell for about five seconds, at intervals of not more than one minute. In a vessel of 100 metres or more the bell sounds forward and the gong aft immediately after."
    },
    "context": "restricted-visibility"
  },
  {
    "id": "rv-aground",
    "rule": 35,
    "cite": [
      "g",
      "h"
    ],
    "scope": "both",
    "name": {
      "en": "Three strokes, bell, three strokes",
      "de": "Drei Schläge, Glocke, drei Schläge"
    },
    "pattern": [
      {
        "kind": "bell-strokes",
        "count": 3
      },
      {
        "kind": "bell-rapid",
        "count": 1
      },
      {
        "kind": "bell-strokes",
        "count": 3
      }
    ],
    "repeatS": 60,
    "meaning": {
      "en": "Vessel aground.",
      "de": "Fahrzeug auf Grund."
    },
    "explanation": {
      "de": "Drei einzelne Schläge vor und nach dem schnellen Läuten. Die drei Schläge sind der Unterschied zum Ankerlieger, der nur läutet.",
      "en": "Three separate and distinct strokes before and after the rapid ringing. Those strokes are the difference from a vessel at anchor, which only rings."
    },
    "context": "restricted-visibility"
  },
  {
    "id": "rv-pilot",
    "rule": 35,
    "cite": [
      "k"
    ],
    "scope": "both",
    "name": {
      "en": "Four short blasts",
      "de": "Vier kurze Töne"
    },
    "pattern": [
      {
        "kind": "short",
        "count": 4
      }
    ],
    "repeatS": 120,
    "meaning": {
      "en": "Pilot vessel engaged on pilotage duty.",
      "de": "Lotsenfahrzeug im Dienst."
    },
    "explanation": {
      "de": "Vier kurze Töne als Erkennungssignal, zusätzlich zu den Signalen nach Regel 35 Absatz (a), (b) oder (g).",
      "en": "Four short blasts as an identity signal, in addition to the signals prescribed in Rule 35(a), (b) or (g)."
    },
    "context": "identity"
  },
  {
    "id": "d-sos",
    "rule": 37,
    "cite": [
      "intro",
      "104:s1:d",
      "32:b",
      "32:c"
    ],
    "scope": "both",
    "name": {
      "de": "SOS: drei kurze, drei lange, drei kurze Töne",
      "en": "SOS: three short, three prolonged, three short"
    },
    "pattern": [
      {
        "kind": "short",
        "count": 3
      },
      {
        "kind": "prolonged",
        "count": 3
      },
      {
        "kind": "short",
        "count": 3
      }
    ],
    "repeatS": 0,
    "meaning": {
      "en": "Distress: I need assistance.",
      "de": "Notfall: Ich brauche Hilfe."
    },
    "explanation": {
      "de": "Die Morsegruppe SOS, mit jedem Signalmittel gegeben. Als Schall sind das drei kurze, drei lange und wieder drei kurze Töne.",
      "en": "The Morse group SOS, made by any signalling method. As sound that is three short, three prolonged and again three short blasts."
    },
    "context": "distress"
  },
  {
    "id": "d-continuous",
    "rule": 37,
    "cite": [
      "intro",
      "104:s1:b"
    ],
    "scope": "both",
    "name": {
      "en": "Continuous sounding",
      "de": "Dauerton"
    },
    "pattern": [
      {
        "kind": "continuous",
        "count": 1
      }
    ],
    "repeatS": 0,
    "meaning": {
      "en": "Distress: I need assistance.",
      "de": "Notfall: Ich brauche Hilfe."
    },
    "explanation": {
      "de": "Ein Dauerton mit dem Nebelsignalgerät.",
      "en": "A continuous sounding with any fog signalling apparatus."
    },
    "context": "distress"
  }
]
